import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext.tsx';

const ComingSoon: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gradient-primary flex items-center justify-center">
      <div className="container-max text-center text-white">
        <div className="max-w-2xl mx-auto">
          {/* Icon */}
          <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in">
            {t('comingsoon.title')}
          </h1>
          
          {/* Subtitle */}
          <p className="text-xl md:text-2xl mb-8 text-white/90 animate-slide-up">
            {t('comingsoon.subtitle')}
          </p>
          
          {/* Description */}
          <p className="text-lg text-white/80 mb-12 max-w-xl mx-auto animate-slide-up">
            {t('comingsoon.description')}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-slide-up">
            <Link
              to="/"
              className="btn-secondary text-lg px-8 py-4 hover:bg-white/20 hover:border-white/30"
            >
              {t('comingsoon.gohome')}
            </Link>
            <Link
              to="/contact"
              className="btn-outline text-lg px-8 py-4 hover:bg-white hover:text-primary-600"
            >
              {t('comingsoon.contact')}
            </Link>
          </div>

          {/* Progress Bar */}
          <div className="mt-16 max-w-md mx-auto">
            <div className="flex justify-between text-sm text-white/70 mb-2">
              <span>{t('comingsoon.progress')}</span>
              <span>75%</span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-2">
              <div className="bg-white h-2 rounded-full transition-all duration-1000 ease-out" style={{ width: '75%' }}></div>
            </div>
          </div>

          {/* Features Preview */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">{t('comingsoon.feature1.title')}</h3>
              <p className="text-white/80 text-sm">{t('comingsoon.feature1.description')}</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">{t('comingsoon.feature2.title')}</h3>
              <p className="text-white/80 text-sm">{t('comingsoon.feature2.description')}</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">{t('comingsoon.feature3.title')}</h3>
              <p className="text-white/80 text-sm">{t('comingsoon.feature3.description')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
